import { relations } from 'drizzle-orm';
import { ehrIntegrations } from '../models/ehrIntegrations';
import { healthRecordUploads } from '../models/healthRecordUploads';
import { patientProfiles } from '../../patient/models/patientProfiles';

/**
 * @group Relations
 * @summary EHR integration relations for the database schema
 *
 * @remarks
 * Defines the relationships for the ehrIntegrations table, including the many-to-one
 * relationship with patient profiles and the one-to-many relationship with health record uploads.
 *
 * @example
 * ```typescript
 * import { ehrIntegrationRelations } from '@shared/db';
 *
 * // Query EHR integration with patient and uploads
 * const integrationWithDetails = await db.query.ehrIntegrations.findFirst({
 *   where: eq(ehrIntegrations.id, integrationId),
 *   with: {
 *     patient: true,
 *     uploads: true
 *   }
 * });
 * ```
 */
export const /**
 * @internal
 */
ehrIntegrationRelations = relations(ehrIntegrations, ({ one, many }) => ({
  patient: one(patientProfiles, {
    fields: [ehrIntegrations.patientId],
    references: [patientProfiles.id],
  }),
  uploads: many(healthRecordUploads),
}));
